import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';
import { Grid, Row, Cell } from '../Grid/Grid.js';
import Paragraph from '../Paragraph/Paragraph.js';
import styles from './footer.css.js';
var currentYear = new Date().getFullYear();

var Footer = function Footer(_ref) {
  var children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'footer' : _ref$component,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 0 : _ref$marginBottom,
      _ref$textMap = _ref.textMap,
      textMap = _ref$textMap === void 0 ? {
    footer: 'HSBC Group'
  } : _ref$textMap;
  return React.createElement(Component, {
    className: cn(styles.Footer, getMarginBottomClass(marginBottom))
  }, React.createElement(Grid, null, React.createElement(Row, null, children || React.createElement(Cell, {
    offsetLarge: 1,
    sizeLarge: 10
  }, React.createElement(Paragraph, {
    marginBottom: 0
  }, "\xA9 ", textMap.footer, " ", currentYear)))));
};

Footer.displayName = 'Footer';
Footer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  component: PropTypes.string,
  textMap: PropTypes.shape({
    footer: PropTypes.node
  })
} : {};
export default Footer;
export { Footer };